import { render, staticRenderFns } from "./driver_add.vue?vue&type=template&id=1b0f8ae4&scoped=true&"
import script from "./driver_add.vue?vue&type=script&lang=js&"
export * from "./driver_add.vue?vue&type=script&lang=js&"
import style0 from "./driver_add.vue?vue&type=style&index=0&id=1b0f8ae4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b0f8ae4",
  null
  
)

export default component.exports